import { Component } from '@angular/core';

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-mediego-api-environment-banner',
  templateUrl: './api-environment-banner.component.html',
  styleUrls: ['./api-environment-banner.component.scss'],
  standalone: false
})
export class ApiEnvironmentBannerComponent {
  get label(): string | null {
    const hostname = window.location.hostname;
    const apiUrl = environment.apiUrl2;

    const isNominalCaseProd = (hostname === 'dashboard.mediego.com' && apiUrl.includes('api.mediego.com'));
    const isNominalCaseQual =(hostname === 'dashboard-qual.mediego.com' && apiUrl.includes('api-qual.mediego.com'));
    // On n'affiche pas le bandeau dans les cas nominaux
    if (isNominalCaseProd || isNominalCaseQual) {
      return null;
    }

    if (apiUrl.includes('api-qual.mediego.com')) return 'API de qualification';
    if (apiUrl.includes('127.0.0.1')) return 'API locale';
    if (apiUrl.includes('api.mediego.com')) return 'API DE PRODUCTION !';

    return `API : ${apiUrl}`;
  }
}
